export const getLanguageDirection = (locale) => {
    var _a, _b, _c;
    const localeInstance = new Intl.Locale(locale);
    /**
     * The type-casting is required because typescript compiler doesn't
     * currently understand complete type of Locale object
     * This will be fixed once we upgrade to TS 4.9.
     */
    return (
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (_c = (_b = (_a = localeInstance) === null || _a === void 0 ? void 0 : _a.textInfo) === null || _b === void 0 ? void 0 : _b.direction) !== null && _c !== void 0 ? _c : 'ltr');
};
//# sourceMappingURL=getLanguageDirection.js.map